import '@atlassian/jira-vendor/src/vendor-parcel.tsx';
import '@atlassian/jira-vendor/src/commons-parcel.tsx';

import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getSpaRoutes } from '@atlassian/jira-routes/src/getSpaRoutes.tsx';
import { startJiraSpa } from './start-jira-spa.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

startJiraSpa(getSpaRoutes);
